module.exports = __webpack_public_path__ + "img/info_square.39fafb4d.svg";